import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DeviceMovementService } from 'app/services/models/device-movement.service';
import { KindService } from 'app/services/models/kind.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-device-movement',
  templateUrl: './create-device-movement.component.html',
  styleUrls: ['./create-device-movement.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreateDeviceMovementComponent implements OnInit {
  @Input() data: { deviceId: number };
  kinds: any[];
  deviceMovementForm: FormGroup;
  date = new Date();

  public dateTimeStartOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,
    defaultDate: this.date
  };

  constructor(
    public activeModal: NgbActiveModal,
    private kindService: KindService,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private deviceMovementService: DeviceMovementService) {

    this.deviceMovementForm = this.fb.group({
      kindId: [null],
      movementDate: [null],
      description: [null]
    });
  }

  async ngOnInit() {
    await this.getAllKinds();
    console.log(this.data);
  }

  closeModal() {
    this.activeModal.close(false);
  }

  async getAllKinds() {
    const data = await this.kindService.getAllKinds('', 0, 100, 14);
    console.log(data);
    this.kinds = data.types;
  }

  async save() {
    if (this.deviceMovementForm.valid) {
      console.log(this.deviceMovementForm.value);
      const date = new Date(this.deviceMovementForm.value.movementDate);
      const data = await this.deviceMovementService.createDeviceMovement(this.data.deviceId, this.deviceMovementForm.value.kindId, date, this.deviceMovementForm.value.description);
      if(data.status == true){
        this.deviceMovementService.sendEvent(true);
        this.toastrService.success(data.message);
        this.closeModal();
      }else{
        this.toastrService.error(data.message);
      }
    }
  }

}